import { createAction, createReducer, createSelector } from '@reduxjs/toolkit'

export const receiveUserData = createAction('userData/receive')

export const userDataReducer = createReducer(null, (builder) => {
  builder.addCase(receiveUserData, (state, action) => action.payload)
})

export const selectUserData = (state) => state.userData

export const selectIsAgent = createSelector(selectUserData, (userData) =>
  userData?.roles?.length
    ? userData.roles.some((role) => role === 'call_center_agent')
    : false
)
